import { baseTheme } from "@boseo/shared/themes";

const theme = {
    ...baseTheme,
};

export default theme;
